// src/core/auth/api/authApi.js
import { http } from '../../../shared/api/http';
import { endpoints } from '../../../shared/api/endpoints';
import { tokenStorage } from '../../../shared/api/storage';

function unwrap(res) {
  return res?.data ?? res; // ✅ http bazen {data:{...}} döndürüyorsa çözer
}

function persistTokens(dto) {
  if (!dto) return;
  const accessToken = dto.accessToken;
  const refreshToken = dto.refreshToken;

  if (accessToken && refreshToken) {
    // tokenStorage.set ne bekliyor bilmiyoruz; en güvenli normalize:
    tokenStorage.set({
      accessToken,
      refreshToken,
      tokenType: dto.tokenType || 'Bearer',
    });
  }
}

export const authApi = {
  async login(dto) {
    const res = await http(endpoints.auth.login, { method: 'POST', body: dto, auth: false });
    const data = unwrap(res);
    persistTokens(data);
    return data;
  },

  async registerIndividual(dto) {
    const res = await http(endpoints.auth.registerIndividual, {
      method: 'POST',
      body: dto,
      auth: false,
    });
    const data = unwrap(res);
    persistTokens(data);
    return data;
  },

  async registerCompany(dto) {
    const res = await http(endpoints.auth.registerCompany, {
      method: 'POST',
      body: dto,
      auth: false,
    });
    const data = unwrap(res);
    persistTokens(data);
    return data;
  },

  async resolveLoginId(payload) {
    const res = await http('/api/v1/auth/resolve-login-id', {
      method: 'POST',
      body: payload,
      auth: false,
    });
    return unwrap(res);
  },

  async verifyEmail(payload) {
    const res = await http('/api/v1/auth/verify-email', {
      method: 'POST',
      body: payload,
      auth: false,
    });
    const data = unwrap(res);
    persistTokens(data);
    return data;
  },

  async resendVerifyEmail(payload) {
    const res = await http('/api/v1/auth/resend-verify-email', {
      method: 'POST',
      body: payload,
      auth: false,
    });
    return unwrap(res);
  },
  async refresh(refreshToken) {
    const res = await http(endpoints.auth.refresh, {
      method: 'POST',
      body: { refreshToken },
      auth: false, // ❗ refresh çağrısı auth header istemez
    });

    const data = unwrap(res);
    persistTokens(data);
    return data;
  },
};
